import { GridRenderCellParams } from '@mui/x-data-grid';
import { ParticipantsConfiguration } from '@thro-types/modules-selections';
import { ShibUser } from '@thro-types/users';

import { TFunction } from 'i18next';

import { translations } from 'locales/i18n';
import { Course } from 'types/AppTypes';

import { ModuleStudentSelection, SelectionState, State } from './ModuleSelections/models';

export const getSeatsForModules = (
  params: GridRenderCellParams<
    { participantsConfigurations: ParticipantsConfiguration[] },
    { participantsConfigurations: ParticipantsConfiguration[] }
  >,
  courses: Course[],
  t: TFunction<'translation', undefined>
) => {
  if (!params.row.participantsConfigurations.length) {
    return null;
  }

  const filteredConfigurations = params.row.participantsConfigurations.filter(
    participantsConfiguration => !!participantsConfiguration.seats
  );

  return (
    filteredConfigurations.length > 0 &&
    t(translations.pages.modules.seatConfiguration(), {
      config: filteredConfigurations
        .map(filteredConfiguration => {
          return `${filteredConfiguration.seats}x${
            filteredConfiguration.isGlobal
              ? 'FÜ'
              : filteredConfiguration.courseOfStudyIds
                  .map(
                    courseOfStudy => courses.find(course => course.id === courseOfStudy)?.shorthand
                  )
                  .join('-')
          }`;
        })
        .join(', ')
    })
  );
};

export function getCurrentSelectionState(selection: ModuleStudentSelection) {
  if (!!selection.state) {
    switch (selection.state) {
      case State.Active:
        return SelectionState.Visible;
      case State.Started:
        return SelectionState.Active;
      case State.Dischargable:
        return SelectionState.SignOutPossible;
      case State.Completed:
        return SelectionState.ReadOnly;
      default:
        return SelectionState.NotVisible;
    }
  }
  return SelectionState.NotVisible;
}

export function studentSemesterParser(degree: string, semester: number) {
  switch (degree) {
    case '84':
      return `B${semester}`;
    case '90':
      return `M${semester}`;
    default:
      return null;
  }
}

interface FilterVariables {
  filter: string;
  offset: number;
}
export const handleModulesFilterQuery = (variables: FilterVariables) => {
  const parsedFilter = JSON.parse(variables.filter);
  const modifiedFilter: Record<string, any> = {
    name: undefined,
    activeState: undefined,
    isTakingPlace: undefined,
    completionState: undefined,
    groupings: undefined
  };

  Object.keys(parsedFilter).forEach(key => {
    modifiedFilter[key] = parsedFilter[key].term;
  });

  modifiedFilter.creatorId = parsedFilter.creatorId?.term?.[0] ?? undefined;

  return modifiedFilter;
};

export const userDataToLecturerOption = (
  userData: ShibUser | string,
  t: TFunction<'translation'>
) => {
  if (typeof userData === 'string') {
    return { label: userData, id: Math.random() * 1000 };
  }

  const salutation = (t: TFunction<'translation', undefined>) => [
    {
      key: 'D',
      label: t(translations.pages.modules.create.GeneralInfo.salutationOther()),
      id: 0
    },
    { key: 'M', label: t(translations.pages.modules.create.GeneralInfo.salutationMale()), id: 1 },
    {
      key: 'F',
      label: t(translations.pages.modules.create.GeneralInfo.salutationFemale()),
      id: 2
    }
  ];

  const label = !!userData?.schacGender
    ? `${salutation(t).find(sal => sal.id === parseInt(userData.schacGender!, 10))?.label} `
    : '';
  const title = !!userData?.title ? `${userData.title} ` : '';

  return {
    label: `${label}${title}${userData?.firstName} ${userData?.lastName}`,
    id: userData?.id
  };
};
